import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { checkAndUpdateVersion } from './Utils/cacheManager';
import { applyTokensToRoot } from './Common/designTokens';

// Apply JS tokens to CSS root so index.css variables are in sync with theme.js
applyTokensToRoot();

const renderApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
  // <React.StrictMode>
      <App />
   //</React.StrictMode>
  );
};

const setupVersionCheck = () => {
  // Re-check version every 5 minutes
  // setInterval(async () => {
  //   const updated = await checkAndUpdateVersion();
  //   if (updated) {
  //     console.log('App updated in background (interval). Reloading...');
  //     const url = new URL(window.location.href);
  //     url.searchParams.set('v', Date.now().toString());
  //     window.location.href = url.toString();
  //   }
  // }, 5 * 60 * 1000);

  // Also check when tab becomes visible again
  document.addEventListener('visibilitychange', async () => {
    if (document.visibilityState === 'visible') {
      const updated = await checkAndUpdateVersion();
      if (updated) {
        console.log('App updated in background (visibility change). Reloading...');
        const url = new URL(window.location.href);
        url.searchParams.set('v', Date.now().toString());
        window.location.href = url.toString();
      }
    }
  });
};

// Initial version check
checkAndUpdateVersion().then((wasUpdated) => {
  if (wasUpdated) {
    console.log('App updated on initial load. Reloading...');
    const url = new URL(window.location.href);
    url.searchParams.set('v', Date.now().toString());
    window.location.href = url.toString();
  } else {
    renderApp();
    console.log('App loaded successfully. No updates found.');
    setupVersionCheck(); // Start periodic and visibility checks
  }
});

reportWebVitals();
